module.exports = __webpack_public_path__ + "img/mobile-womens-apparel-banner.2578643a.jpg";